import { useState, useRef, useEffect } from 'react'

const SCROLL_START_OFFSET = 10

/**
 * Custom hook to determine if the user is currently scrolling vertically (Y-axis).
 */
const useIsScrollingY = (): boolean => {
  const [isScrollingY, setIsScrollingY] = useState(false)
  const previousScrollY = useRef<number>(window.scrollY)

  useEffect(() => {
    const handleScroll = (): void => {
      const currentScrollY = window.scrollY
      const difference = Math.abs(currentScrollY - previousScrollY.current)

      if (difference > SCROLL_START_OFFSET) {
        setIsScrollingY(true)
      } else {
        setIsScrollingY(false)
      }

      previousScrollY.current = currentScrollY
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return isScrollingY
}

export default useIsScrollingY
